<template>
    <div class="sustainability-header">
        <app-header-mini v-if="this.$route.params.page === 'environment'" :img="'/static/img/sustainability/environment/header.jpg'" :texts="texts"></app-header-mini>
        <app-header-mini v-if="this.$route.params.page === 'health-and-safety'" :img="'/static/img/sustainability/has/header.jpg'" :texts="texts"></app-header-mini>
        <app-header-mini v-if="this.$route.params.page === 'sustainability-reports'" :img="'/static/img/sustainability/has/header.jpg'" :texts="texts"></app-header-mini>
        <app-header v-if="this.$route.params.page === 'responsibility'" :cover="slidesResponsibility" :texts="texts"></app-header>
    </div>
</template>

<script>
import Header from "../shared/Header";
import HeaderMini from "../shared/HeaderMini";
export default {
  components: {
    appHeader: Header,
    appHeaderMini: HeaderMini
  },
  data() {
    return {
      slidesResponsibility: [
        "/static/img/sustainability/responsibility/header.jpg",
        "image"
      ],
      texts: ["Устойчиво развитие"]
    };
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sustainability/Header.vue